import MicroModal from "micromodal";

export class Awards {
  constructor() {}
  init() {
    // window.addEventListener("DOMContentLoaded", () => {
    //   this.body = document.getElementsByTagName("body")[0];
    //   this.html = document.getElementsByTagName("html")[0];

    //   // スクロール時
    //   window.addEventListener("scroll", () => {
    //   });

    //   // ウインドウリサイズ時
    //   window.addEventListener("resize", () => {
    //   });
    // });

    // load時
    // ------------------------------
    window.addEventListener("load", () => {
      if (document.querySelectorAll(".js-modal-trigger")[0]) {
        //console.log("Awards init");

        //MicroModal.init();
        MicroModal.init({
          onShow: (modal) => console.info(`${modal.id} is shown`), // [1]
          onClose: (modal) => console.info(`${modal.id} is hidden`), // [2]
          openTrigger: "data-micromodal-trigger", // [3]
          closeTrigger: "data-micromodal-close", // [4]
          openClass: "is-open", // [5]
          disableScroll: true, // [6]
          disableFocus: false, // [7]
          awaitOpenAnimation: false, // [8]
          awaitCloseAnimation: false, // [9]
          debugMode: true, // [10]
        });
      }
    });
  }
}
